import axios from "axios";

const API_URL = "https://srinivasafleet.com/api";

export const getDashboardSummary = async () => {
  const token = localStorage.getItem("token");
  const response = await axios.get(`${API_URL}/dashboard/`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};